__turbopack_context__.v({
  "button-aligned-container": "addressDetails-module-scss-module__89H83a__button-aligned-container",
  "buttons-container": "addressDetails-module-scss-module__89H83a__buttons-container",
  "centered": "addressDetails-module-scss-module__89H83a__centered",
  "checkbox": "addressDetails-module-scss-module__89H83a__checkbox",
  "content": "addressDetails-module-scss-module__89H83a__content",
  "gap": "addressDetails-module-scss-module__89H83a__gap",
  "instruction": "addressDetails-module-scss-module__89H83a__instruction",
});
